var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStartElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 366,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee004100",
    d: "M0-10879h1440V2370H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee004100",
    d: "M0-747.5 1440-578v862H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB3054",
    d: "M0 186h1440v634H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B1F3C",
    d: "m719.539 365.94 741.463-176.983-2.036-63.496-741.463 176.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#680E24",
    d: "m717.5 303.417 741.463-176.983-2.036-63.496L715.464 239.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B1F3C",
    d: "M719.465 366.073-21.998 189.09l2.036-63.496L721.5 302.577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F0513",
    fillRule: "evenodd",
    d: "m723.301 239.023-7.836 1.871-.121-3.77-733.27-175.027L-15.89-1.4 723.3 175.041 1454.89.414l2.04 63.497-733.389 175.055-.004.114z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#680E24",
    d: "M721.5 302.576-19.963 125.593l2.036-63.496L723.536 239.08z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee004100",
    d: "M0-10879h1440V2370H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStartElement);
export default __webpack_public_path__ + "static/media/getStartElement.1aa300fa9c66f198522746ecd68da6a2.svg";
export { ForwardRef as ReactComponent };